import {
  IProduct,
  IProductSchemaUI,
  ProductStatusEnum,
} from '@monetize/types/app';
import { useNavigate } from 'react-router-dom';
import { usePerformEntityAction } from '../../../api/queryUtils';
import { MDataTableActions } from '../../../components/Monetize';
import { ROUTES } from '../../../constants';
import { useSettingsReadOnlyRule } from '../../../hooks/useSettingsReadOnlyRule';

interface ProductProps {
  product: IProductSchemaUI;
  source: 'LIST' | 'DETAIL';
  onSelectEdit?: (id: string) => void;
}

export const ProductActions = ({
  product,
  source,
  onSelectEdit,
}: ProductProps) => {
  const navigate = useNavigate();
  const { id, status, name } = product;

  const { mutateAsync: doActivateDeactivate } =
    usePerformEntityAction<IProduct>('productCatalogProducts', {
      meta: { showErrorToast: true },
    });
  const { canCreateSettings } = useSettingsReadOnlyRule();

  if (!id || !canCreateSettings) {
    return null;
  }

  const confirmProps = {
    title: `Are you sure you want to deactivate "${product.name}"?`,
    description: 'Once deactivated, this product will no longer be available.',
  };

  const actions = [
    {
      title: 'Edit',
      enabled: source === 'LIST',
      action: () => onSelectEdit?.(id),
    },
    {
      title: 'Clone',
      enabled: true,
      action: () =>
        product?.id && navigate(ROUTES.getProductCloneCreateRoute(id)),
    },
    {
      title: 'Activate',
      enabled: status === ProductStatusEnum.INACTIVE,
      action: () => doActivateDeactivate({ id, action: 'activate' }),
    },
    {
      title: 'Deactivate',
      color: 'danger',
      confirmProps: {
        ...confirmProps,
        yesButton: 'Deactivate',
      },
      enabled: status === ProductStatusEnum.ACTIVE,
      action: () => doActivateDeactivate({ id, action: 'deactivate' }),
    },
  ];
  return <MDataTableActions actions={actions} />;
};
